import {connect} from 'react-redux';

import {changeProduct} from '../../actionCreators';

const ProductItem = ({title, isFavourite, onClick}) => (
    <li onClick={onClick} className={isFavourite ? 'is-favorite' : 'not-favorite'}>
        {title}
    </li>
);

const mapDispatchToProps = (dispatch, {id}) => ({
    onClick: () => dispatch(changeProduct(id)),
});

export default connect(undefined, mapDispatchToProps)(ProductItem);
